import React, { useMemo } from "react";
import Facebook from "@tiendeo/react-components/dist/atoms/Icons/Facebook";
import Instagram from "@tiendeo/react-components/dist/atoms/Icons/Instagram";
import Twitter from "@tiendeo/react-components/dist/atoms/Icons/Twitter";
import Alert from "@tiendeo/react-components/dist/atoms/Icons/Alert";

import {
    SocialsLink,
    SocialButtonsWrapper,
    FooterSocialsTitle,
    SocialItemsWrapper,
} from "./Footer.styles";
import useTranslation from "translations/useTranslation";
import useConfigs from "hooks/useConfigs";

interface SocialButtonIconProps {
    iconText: string;
}

const SocialButtonIcon = ({ iconText }: SocialButtonIconProps) => {
    switch (iconText) {
        case "facebook":
            return <Facebook width={32} />;
        case "instagram":
            return <Instagram width={32} />;
        case "twitter":
            return <Twitter width={32} />;
        case "newsletter":
            return <Alert width={32} />;
    }
};

interface SocialsListProps {
    socials: ISocial[];
}

const SocialsList = ({ socials }: SocialsListProps) => {
    return (
        <>
            {socials.map((social) => (
                <SocialsLink
                    key={social.label}
                    title={social.label}
                    href={social.url}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={"itemFooterSocial" + social.label}
                >
                    <SocialButtonIcon iconText={social.label} />
                </SocialsLink>
            ))}
        </>
    );
};

type ISocial = {
    label: string;
    url: string;
};

const SocialButtons = () => {
    const t = useTranslation();
    const { url_facebook, url_twitter, url_instagram, url_alerts } = useConfigs();

    const socials: ISocial[] = useMemo(
        () =>
            [
                {
                    label: "facebook",
                    url: url_facebook,
                },
                {
                    label: "twitter",
                    url: url_twitter,
                },
                {
                    label: "instagram",
                    url: url_instagram,
                },
                {
                    label: "newsletter",
                    url: url_alerts,
                },
            ].filter((x) => !!x.url),
        [url_facebook, url_twitter, url_instagram, url_alerts],
    );

    return (
        <SocialButtonsWrapper>
            <FooterSocialsTitle>{t("FOLLOW_TIENDEO")}</FooterSocialsTitle>
            <SocialItemsWrapper data-testid="footerSocial">
                <SocialsList socials={socials} />
            </SocialItemsWrapper>
        </SocialButtonsWrapper>
    );
};

export default SocialButtons;
